export default __webpack_public_path__ + "static/media/ambassador_monika_belohlavkova.0bf7683c.jpg";